import { titleCase } from "@memorang/helpers/common";
import { useTranslation } from "react-i18next";
import { Appbar } from "react-native-paper";
import Box from "./Box";
import ChallengeListItem from "./ChallengeListItem";
import { CustomBreadcrumb } from "./CustomBreadcrumb";
import { CustomListSubheader } from "./CustomListSubheader";
import ScrollContainer from "./ScrollContainer";

type Item = {
	id: number;
	title: string;
	description: string;
	imageUri: string;
};

type Props = {
	challenges: Item[];
	type: string;
	handlePressChallenge: (id: number) => void;
	onNavigateBack: () => void;
};

const MoreChallengesView = ({
	challenges,
	type,
	handlePressChallenge,
	onNavigateBack,
}: Props) => {
	const { t } = useTranslation();
	const typeLabel = titleCase(type);

	const breadcrumbs = [
		{
			label: t("moreChallenges.challenges"),
			action: onNavigateBack,
		},
		{
			label: typeLabel,
		},
	];

	return (
		<>
			<Appbar.Header mode="medium">
				<Appbar.BackAction onPress={onNavigateBack} />
				<Appbar.Content
					title={<CustomBreadcrumb breadcrumbs={breadcrumbs} />}
				/>
			</Appbar.Header>
			<ScrollContainer
				maxWidth="sm"
				contentContainerStyle={{
					paddingBottom: 100,
				}}
			>
				<Box paddingTop={8}>
					<CustomListSubheader>
						{t("moreChallenges.challengesCount", { value: challenges.length })}
					</CustomListSubheader>
					{challenges.map((challenge) => (
						<ChallengeListItem
							key={challenge.id}
							{...challenge}
							onPress={() => handlePressChallenge(challenge.id)}
						/>
					))}
				</Box>
			</ScrollContainer>
		</>
	);
};

export default MoreChallengesView;
